/**
 * ╔════════════════════════════════════════════════════════════╗
 * ║  TOOLS CORE PHILOSOPHY                                     ║
 * ╠════════════════════════════════════════════════════════════╣
 * ║  Core Philosophy of Tools: Using the Right Tools Correctly          ║
 * ╚════════════════════════════════════════════════════════════╝
 */

export const TOOLS_CORE = `
# Tools Usage Philosophy

Use the right tool for the right job:
1. Understand each tool's capabilities and limitations
2. Choose the most appropriate tool for each task
3. Use tools efficiently and correctly
4. Validate tool outputs

Proper tool usage amplifies effectiveness.
`;
